import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"
import { Link } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export function HomeSupportCard() {
  const { data: boundlessConfig } = usePublicBoundlessConfigRetrieveSuspense()

  return (
    <Card>
      <CardHeader>
        <CardTitle>Support</CardTitle>
      </CardHeader>
      <CardContent>
        We are here to help! Book a call with the Boundless team to discuss your
        partnership or address platform questions.
      </CardContent>
      <CardFooter>
        <Button asChild>
          <Link to={boundlessConfig.bookACallUrl ?? "/"}>Talk to us</Link>
        </Button>
      </CardFooter>
    </Card>
  )
}
